export const idlFactory = ({ IDL }) => {
  const ChatMessage = IDL.Record({ 'content' : IDL.Text, 'role' : IDL.Text });
  const ChatRequest = IDL.Record({
    'context' : IDL.Opt(IDL.Text),
    'messages' : IDL.Vec(ChatMessage),
    'conversation_id' : IDL.Opt(IDL.Text),
  });
  const ChatResponse = IDL.Record({
    'cost_estimate' : IDL.Float64,
    'conversation_id' : IDL.Text,
    'tokens_used' : IDL.Nat32,
    'message' : IDL.Text,
  });
  const Result_ChatResponse = IDL.Variant({
    'Ok' : ChatResponse,
    'Err' : IDL.Text,
  });
  const FrontendAssistedRequest = IDL.Record({
    'context' : IDL.Opt(IDL.Text),
    'output_tokens' : IDL.Nat32,
    'messages' : IDL.Vec(ChatMessage),
    'conversation_id' : IDL.Opt(IDL.Text),
    'claude_response' : IDL.Text,
    'input_tokens' : IDL.Nat32,
  });
  const Result_Text = IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text });
  const UsageStats = IDL.Record({
    'total_queries' : IDL.Nat32,
    'avg_cost_per_query' : IDL.Float64,
    'total_cost_usd' : IDL.Float64,
    'total_tokens' : IDL.Nat32,
  });
  return IDL.Service({
    'chat' : IDL.Func([ChatRequest], [Result_ChatResponse], []),
    'chat_frontend_assisted' : IDL.Func(
        [FrontendAssistedRequest],
        [Result_ChatResponse],
        [],
      ),
    'claim_admin' : IDL.Func([], [Result_Text], []),
    'get_admin_principal' : IDL.Func([], [IDL.Opt(IDL.Principal)], ['query']),
    'get_api_key_for_frontend' : IDL.Func([], [Result_Text], ['query']),
    'get_infrastructure_context' : IDL.Func([], [IDL.Text], []),
    'get_model_name' : IDL.Func([], [IDL.Text], ['query']),
    'get_system_prompt' : IDL.Func([], [IDL.Text], ['query']),
    'get_usage_statistics' : IDL.Func([], [UsageStats], ['query']),
    'is_configured' : IDL.Func([], [IDL.Bool], ['query']),
    'set_api_key' : IDL.Func([IDL.Text], [], []),
    'set_discovery_doctor_principal' : IDL.Func([IDL.Principal], [], []),
    'set_knowledge_base_principal' : IDL.Func([IDL.Principal], [], []),
    'set_system_prompt' : IDL.Func([IDL.Text], [], []),
    'set_vector_db_principal' : IDL.Func([IDL.Principal], [], []),
  });
};
export const init = ({ IDL }) => { return []; };
